<app-container class="my-10">
	<app-llc-sync-header class="mt-5"></app-llc-sync-header>

	<div class="flex mt-10">
		<div class="flex-1">
			<app-input
				[startIcon]="ICON.DOLLAR"
				[disabled]="true"
				label="Purchase price"
				[ngModel]="mortgagePurchasePrice"
			></app-input>
		</div>
		<div class="flex justify-center items-end w-24">
			<div
				class="border rounded-xl py-2 px-4"
				[ngClass]="{
					'bg-red-lighter text-red border-red-light': !equal,
					'bg-green-lightest text-green border-green-lighter': equal,
				}"
			>
				<app-icon *ngIf="equal" [icon]="ICON.EQUAL"></app-icon>
				<app-icon *ngIf="!equal" [icon]="ICON.NOT_EQUAL"></app-icon>
			</div>
		</div>
		<div class="flex-1">
			<app-input
				type="cents"
				label="Purchase price"
				[ngModel]="purchasePrice"
			></app-input>
		</div>
	</div>

	<div class="mt-10 mb-5 flex justify-center">
		<atomic-message-bar type="success" *ngIf="equal"
			>It's a match! The purchase price in your matter matches that of the
			lender's file.</atomic-message-bar
		>
		<atomic-message-bar type="error" *ngIf="!equal"
			>The purchase price you have on file does not match the lender's records.
			You may need to inform the lender.</atomic-message-bar
		>
	</div>
</app-container>

<div class="text-right mt-5 mb-2 text-sm">
	<span *ngIf="!equal"
		>The lender's purchase price will override your value in Closer if you
		choose to sync.</span
	>
	<span *ngIf="equal"
		>Click "Continue" to proceed to the syncing of other matter data.</span
	>
</div>

<div class="flex flex-1 justify-end">
	<app-button btn="secondary" (click)="_next()" size="small" class="mr-3"
		>Skip</app-button
	>
	<app-button (click)="_next()" size="small" *ngIf="equal">Continue</app-button>
	<app-button (onClick)="sync()" size="small" *ngIf="!equal">Sync</app-button>
</div>
